export default null;throw new Error("Unable to resolve \"./parser-sync\" from npm:pngjs@5.0.0/browser.js");